import CardItem from 'Components/ProgramFinder/CardItem/saf';
import { useEffect, useRef } from 'react'

const CardList = ({list = []}) => {
  const listRef = useRef();
  useEffect(() => {
    // eslint-disable-next-line no-undef
    Drupal.attachBehaviors(listRef.current);
  }, []);

  if (!list.length) {
    return '';
  }

  return (
    <div className="program-finder__items-wrapper" ref={listRef}>
      {
        list && list.map((item) => {
          return <CardItem data={item} key={`${item.nid}-${item.langcode}`}/>
        })
      }
    </div>
  );
};

export default CardList;
